import permissions from "app/permissions";
import { DETAILS, EmployeeServicePath, STAFF_REQUEST } from "utils/constants";
import DetailsStaffRequests from "./DetailsStaffRequests";

export const resources = {
  isMenu: false,
  name: EmployeeServicePath + DETAILS + "/" + STAFF_REQUEST + "/:id",
  custom: <DetailsStaffRequests />,
  permission: permissions.canPreviewStaffRequests,
};
